import { styled } from '@mui/material/styles';
import { Box, Button, Grid, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getBusinessPalette } from './businessPalette';

export const StyledDatePicker = styled(DatePicker, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ theme, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ffffff',
      '& fieldset': {
        borderColor: '#ccc',
      },
      '&:hover fieldset': {
        borderColor: '#bbb',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#aaa',
      },
    },
    '& .MuiInputBase-input': {
      backgroundColor: '#ffffff',
    },
    '& .MuiPickersCalendarHeader-root': {
      backgroundColor: '#ffffff',
      color: '#555',
      '& .MuiPickersArrowSwitcher-root button': {
        color: '#555',
      },
    },
    '& .MuiPickersDay-root': {
      width: '50px',
      height: '50px',
      fontSize: '1.2rem',
      '&.Mui-selected': {
        backgroundColor: `${palette.datePickerSelectedDayBg} !important`,
        color: '#fff',
        '&:hover': {
          backgroundColor: palette.datePickerSelectedDayHoverBg,
        },
      },
      '&.MuiPickersDay-dayOutsideMonth': {
        color: '#B3B3B3',
      },
      '&.MuiPickersDay-today': {
        border: `2px solid ${palette.datePickerTodayBorder}`,
      },
      '&:hover': {
        backgroundColor: palette.datePickerDayHoverBg,
      },
    },
    '& .MuiPickersCalendarHeader-switchHeader': {
      '& .MuiTypography-root': {
        fontSize: '1.3rem',
        fontWeight: 'bold',
      },
    },
    '& .MuiPickersArrowSwitcher-root': {
      fontSize: '2rem',
    },
  };
});

export const TimeSlotButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'businessId',
})(({ theme, selected, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    margin: theme.spacing(1),
    padding: theme.spacing(1, 2),
    borderRadius: '8px',
    border: selected
      ? `2px solid ${palette.timeSlotSelectedBorder}`
      : '1px solid #ccc',
    backgroundColor: selected ? palette.timeSlotSelectedBg : '#fff',
    color: selected ? 'black' : '#000',
    minWidth: '75px',
    '&:hover': {
      backgroundColor: selected
        ? palette.timeSlotSelectedHoverBg
        : palette.datePickerDayHoverBg,
    },
  };
});

export const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ theme, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
    textAlign: 'center',
    background: palette.dateBoxBg,
    padding: theme.spacing(4),
    borderRadius: '20px',
    boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)',
    maxWidth: '550px',
    margin: 'auto',
    border: `2px solid ${palette.dateBoxBorder}`,
  };
});

export const SectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  fontWeight: 'bold',
  color: 'black',
}));

export const TimeSlotsGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const ConfirmButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'businessId',
})(({ theme, businessId }) => {
  const palette = getBusinessPalette(businessId);

  return {
    marginTop: theme.spacing(4),
    fontWeight: 'bold',
    boxShadow: 'none',
    backgroundColor: palette.buttonBg,
    '&:hover': {
      backgroundColor: palette.buttonHoverBg,
    },
    '&:disabled': {
      backgroundColor: '#CCCCCC',
      color: '#FFFFFF',
      boxShadow: 'none',
    },
  };
});